import React, { useState, useEffect } from "react";
import "./Cases.css";
import case1 from '../metaverseassets/case1.png';
import case2 from '../metaverseassets/case2.png';
import case3 from '../metaverseassets/case3.png';
import case4 from '../metaverseassets/case4.png';
import case5 from '../metaverseassets/case5.png';
import case6 from '../metaverseassets/case6.png';
import case7 from '../metaverseassets/case7.png';
import case8 from '../metaverseassets/case8.png';

export default function Cases() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);

  const cases = [
    { img: case1, name: "Virtual real estate and digital land platforms" },
    { img: case2, name: "Metaverse gaming and entertainment" },
    { img: case3, name: "Virtual events and social platforms" },
    { img: case4, name: "Enterprise collaboration environments" },
    { img: case5, name: "Education and training simulations" },
    { img: case6, name: "NFT-powered virtual marketplaces" },
    { img: case7, name: "Branded virtual showrooms and experiences" },
    { img: case8, name: "Industrial simulations and digital twins" },
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setCardsToShow(3);
      } 
      else if (window.innerWidth >= 576) {
        setCardsToShow(2);
      } 
      else {
        setCardsToShow(1);
      }
      setCurrentSlide(0);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="metaverse-cases" className="metaversemainclass">
      <h2 className="heading">Leading Use Cases for Metaverse Development</h2>
      <p className="subheading">
        Explore how immersive virtual environments unlock new business possibilities.
      </p>

     <div className="cards">
        {cases.map((item, index) => (
          <div className="card" key={index}>
            <img src={item.img} alt="error" />
            <span>{item.name}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(-${(100 / cardsToShow) * currentSlide}%)`,
            }}
          >
            {cases.map((item, index) => (
              <div
                className="card"
                key={index}
               style={{
  flex: `0 0 calc(${100 / cardsToShow}% - ${
    cardsToShow === 1 ? 0 : ((cardsToShow - 1) * 20) / cardsToShow
  }px)`,
}}
              >
                <img src={item.img} alt="error" />
                <span>{item.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="carousel-dots">
          {cases.map((_, index) => (
            <button
              key={index}
              className={`dot ${currentSlide === index ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
